import React from 'react';
import './FooterSE.css';
import { Link } from 'react-router-dom';

const FooterSE = ({ translations }) => {
  return (
    <div className="sr-footer">
      <div>
        SLUTFÖR 25 ERBJUDANDEN FÖR ATT BEGÄRA ETT INCITAMENT ELLER SLUTFÖR FÄRRE ERBJUDANDEN
        FÖR ATT BEGÄRA INCITAMENT AV LÄGRE VÄRDE. TILLGÄNGLIGT VIA BANKÖVERFÖRING OCH PRESENTKORT.
      </div>
      <div>
        *VID SLUTFÖRANDE AV KÖP OCH PROGRAMKRAV. Handelsnamn eller rättigheter associerade med
        alla varumärken på denna webbplats tillhör respektive ägare och är inte anslutna till
        denna kampanj.
      </div>
      <div className="footer-links">
        <Link to="/se/integritetspolicy" target="_blank" rel="noopener noreferrer">
          {translations?.footer?.privacyPolicy || 'Integritetspolicy'}
        </Link>
        {' | '}
        <Link to="/se/villkor" target="_blank" rel="noopener noreferrer">
          {translations?.footer?.termsAndConditions || 'Villkor'}
        </Link>
      </div>
      <div className="footer-copyright">
        {translations?.footer?.copyright || '© 2026 Rewards & Samples, LLC. Alla rättigheter förbehållna.'}
      </div>
    </div>
  );
};

export default FooterSE;
